import { Button } from "@mui/material";
import * as Sentry from "@sentry/react";
import { useTranslation } from "react-i18next";

import RetryableErrorState from "~/components/RetryableErrorState";
import isChunkLoadError from "~/helpers/chunkLoadError";

interface SentryRouteFallbackProps {
	componentStack: string;
	error: unknown;
	eventId: string;
	pageTitle: string;
	resetError: () => void;
}

const describeRouteError = (error: unknown): string => (error instanceof Error ? error.message : String(error));

const openReportDialog = (eventId: string) => Sentry.showReportDialog({ eventId });

const reloadApp = () => window.location.reload();

const SentryRouteFallback = ({ error, eventId, pageTitle, resetError }: SentryRouteFallbackProps) => {
	const { t } = useTranslation("common");
	const isStaleChunk = isChunkLoadError(error);
	const message = isStaleChunk
		? t("dock.routeError.reloadAppMessage")
		: t("dock.routeError.message", { detail: describeRouteError(error) });

	return (
		<RetryableErrorState
			message={message}
			onRetry={isStaleChunk ? reloadApp : resetError}
			retryLabel={isStaleChunk ? t("dock.routeError.reloadApp") : t("dock.routeError.reload")}
			secondaryAction={
				eventId && (
					<Button color="inherit" onClick={() => openReportDialog(eventId)} size="small">
						{t("dock.routeError.report")}
					</Button>
				)
			}
			title={pageTitle}
		/>
	);
};

export default SentryRouteFallback;
